import React from 'react';
import { Button } from 'semantic-ui-react';
import styles from './JoynFSMPopup.module.css';
import { closeIconSvg } from '../../HelperMethods/constants';

export default function JoynFSMPopup({ title, message, show, onClose }) {
  if (show) {
    return (
      <div className="joyn2-loader-container">
        <div className={styles.popupBox}>
          <div className={styles.popupHeader}>
            <div className={styles.popupHeaderText}>{title}</div>
            <div>
              <img
                src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(closeIconSvg)}`}
                style={{ cursor: 'pointer' }}
                alt="Close Icon"
                onClick={onClose}
              />
            </div>
          </div>
          <div className={styles.popupMessage}>{message}</div>
          <div className={styles.popupFooter}>
            <Button className="black" onClick={onClose}>
              Ok
            </Button>
          </div>
        </div>
      </div>
    );
  }
  return null;
}
